const hasLocalizedStatisticsPage = (locale: string | undefined) => locale && ([
  'nl-NL',
  'en-GB',
  'de-DE',
  'es-ES',
  'fr-FR',
  'en_IN',
  'it-IT',
  'es-PE',
  'es-CO',
  'es-AR',
  'es-CL',
].includes(locale));

export default hasLocalizedStatisticsPage;
